module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contentWrap"
    }
  }, [_c('div', {
    staticClass: "content left"
  }, [_c('div', {
    staticClass: "left",
    attrs: {
      "id": "content_1block"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "msgblock"
  }, [_vm._v("Please enter your registered email in the box below. An email will be sent to you to reset password.")]), _vm._v(" "), _c('div', {
    staticClass: "pure-form pure-form-aligned"
  }, [_c('fieldset', {
    staticStyle: {
      "margin-left": "120px"
    }
  }, [_c('div', {
    staticClass: "pure-control-group",
    staticStyle: {
      "line-height": "50px"
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "pure-input-1-2",
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pure-controls",
    staticStyle: {
      "margin-left": "180px"
    }
  }, [_c('button', {
    staticClass: "button-warning pure-button pure-button-primary",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "reset",
      "value": "Reset"
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button-warning pure-button pure-button-primary",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.confirm()
      }
    }
  }, [_vm._v("Confirm")])])])])])]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content_top"
    }
  }, [_c('div', {
    staticClass: "content_title_full left"
  }, [_vm._v("Forgot Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-621adf64!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Forgetpsw.vue
// module id = 111
// module chunks = 1